export default __webpack_public_path__ + "static/media/cat1.a6c5b389.png";